import type { FaireProductEntity } from "../../entity_types/product";

export const p_p9gy726jgu: FaireProductEntity = {
  token: "p_p9gy726jgu",
  type: "product",
  name: "Perfect Clean 2 -in -1  Scalp Scrub + Clarifying Shampoo",
  brandToken: "b_1t2tge9kwv",
  brandName: "Naturelab. TOKYO",
  imageUrl:
    "https://cdn.faire.com/fastly/8b3a0676f24ae30fda8826445841d5c69f5b10641f1562f29fe41c197a0c6924.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/601a6f742c9d70acbfd16a253368e2d87cb2178c2c1c2b44083c60eccd9adede.jpeg",
    "https://cdn.faire.com/fastly/29e94b5ebcc57bb4ad52c59d5952e5075e83884c1538d1969c2848529367e850.png",
    "https://cdn.faire.com/fastly/95aed459225b3bbc34ef31b7d6611adfc2cf2e84c43fad4540126eb8524e3ae1.jpeg",
    "https://cdn.faire.com/fastly/2165b67d8788fb4676f1d2a58dbe92a35d811390d648541000dddb540228e2ce.png",
  ],
  priceDollars: 11.99,
  description:
    "The NatureLab. Tokyo Perfect Clean Clarifying Scalp Scrub is a 2-in-1 sugar scrub + shampoo with probiotic-rich sake water. Gently removes product build up and environmental impurities to reveal healthy scalp and immensely shiny hair.\n\n8.1 OZ / 230G \n\nHOW TO USE:\nOnce a week, in place of your Shine Shampoo, apply scrub on damp hair from scalp to ends in a circular motion and rinse.\n\nFREE OF:\nSulfates, Paraben, Gluten, Phthalate, Mineral Oil, Cruelty. \n\nFRAGRANCE: \nA refreshingly light, soft scent with notes of violet and almond.\n\nKEY INGREDIENTS:\n・HYALURONIC ACID\nCan absorb 1,000 times its own weight to secure moisture and add fullness to hair.\n\n・GRAPE EXTRACT\nA source of powerful antioxidants that helps to reduce the environmental damage to hair and scalp.\n\n・PLATINUM FIBER\nCoats the hair with a platinum like shine without adding extra weight, lifting hair's natural reflective ",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:38.382Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
